import React, {useMemo} from 'react';
import {Button, Group, Modal, Select, Text, Textarea} from "@mantine/core";
import { useGetReasonCodesQuery } from '@repo/services';
import {capitalizeFirstLetterOnly} from "@repo/utils";
import {IconCircleX, IconThumbDown} from "@tabler/icons-react";
import {UseFormReturnType} from "@mantine/form";

interface OpportunityDeclineModalProps {
    form: UseFormReturnType<any>;
    declineModalOpen: boolean;
    closeDeclineModal: () => void;
    opportunityTitle: string;
    loading: boolean;
    handleDecline: (aimOpportunity?: number | null) => void;
}

/**
 * A modal dialog that confirms opportunity decline with a reason code selector and comments field.
 */
const OpportunityDeclineModal = ({ form, declineModalOpen, closeDeclineModal, opportunityTitle, loading, handleDecline }:OpportunityDeclineModalProps) => {
    const { data: reasonCodes = [] } = useGetReasonCodesQuery(null);
    const declineReasonCodes = useMemo(() => {
        return reasonCodes.filter(
            (reasonCode) => reasonCode.validForOpportunities && reasonCode.validForNegativeDecisions
        );
    }, [reasonCodes]);

    return (
        <>
            <Modal opened={declineModalOpen} onClose={closeDeclineModal} title="Confirm Decline" centered>
                <Text>{`You are declining opportunity "${opportunityTitle}". Please confirm and provide comments below.`}</Text>
                <form>
                    <Select
                        mt={20}
                        withAsterisk
                        label="Reason"
                        placeholder="Reason"
                        data={declineReasonCodes?.map((t) => { return { label: capitalizeFirstLetterOnly(t?.description), value: t?.aimReasonCode } })}
                        {...form.getInputProps('reason')}
                    />
                    <Textarea
                        mt={20}
                        withAsterisk
                        label="Comments"
                        placeholder="Comments"
                        {...form.getInputProps('comments')}
                    />
                    <Group >
                        <Button
                            color="red"
                            mt={20}
                            rightSection={<IconThumbDown size={14} />}
                            onClick={handleDecline as any}
                            loading={loading}
                        >
                            Confirm
                        </Button>
                        <Button
                            color="gray"
                            mt={20}
                            rightSection={<IconCircleX size={14} />}
                            onClick={closeDeclineModal}
                        >
                            Close
                        </Button>
                    </Group>
                </form>
            </Modal>
        </>
    );
};

export default OpportunityDeclineModal;
